import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import useVendorFields from "./AddNewFields.hook";
import { DashboardLoader } from "../../utils/Loading";
import { LoadingButton } from "@mui/lab";
import SaveIcon from "@mui/icons-material/Save";

const AddNewFields = (props) => {
  const {
    Loading,
    fieldsData,
    handleChange,
    dataItem,
    dynamicDBValues,
    AddNewFields,
    handleDeleteField,
    btnLoading,
  } = useVendorFields(props);

  const renderValueField = () => {
    if (dataItem?.vchFieldType === "dynamic") {
      return (
        <FormControl sx={{ m: 1, minWidth: "95%" }}>
          <InputLabel id="vchFieldValue" required size="small">
            Value
          </InputLabel>
          <Select
            variant="outlined"
            size="small"
            labelId="vchFieldValue"
            id="vchFieldValue-modal"
            value={dataItem?.vchFieldValue}
            onChange={(e) => handleChange("vchFieldValue", e.target.value)}
          >
            {dynamicDBValues?.map((i) => (
              <MenuItem key={i} value={i}>
                {i}
              </MenuItem>
            ))}
          </Select>{" "}
        </FormControl>
      );
    } else if (dataItem?.vchFieldType === "static") {
      return (
        <FormControl sx={{ m: 1, minWidth: "95%", border: "none" }}>
          <TextField
            size="small"
            label="Value"
            variant="outlined"
            required
            value={dataItem?.vchFieldValue}
            onChange={(e) => {
              handleChange("vchFieldValue", e.target.value);
            }}
          />
        </FormControl>
      );
    } else {
      return (
        <div className="w-full">
          <FormControl sx={{ m: 1, minWidth: "95%", border: "none" }}>
            <FormControlLabel
              sx={{ pl: 2 }}
              style={{fontSize:'0.75rem'}}
              control={
                <Switch
                  checked={dataItem?.isStaticFirst}
                  onChange={(e) =>
                    handleChange("isStaticFirst", e.target.checked)
                  }
                  size="small"
                  name="isStaticFirst"
                  id="isStaticFirst"
                  label="Is Static Value First?"
                  
                />
              }
              label={<span style={{ fontSize: '0.75rem' }}>{"Is Static Value First?"}</span>}
            />
          </FormControl>
          {dataItem?.isStaticFirst ? (
            <div className="w-full">
              <FormControl sx={{ m: 1, width: "45%", border: "none" }}>
                <TextField
                  size="small"
                  variant="outlined"
                  required
                  placeholder="Static Value"
                  value={dataItem?.staticValue}
                  onChange={(e) => {
                    handleChange("staticValue", e.target.value);
                  }}
                />
              </FormControl>
              <FormControl sx={{ m: 1, width: "45%" }}>
                <Select
                  variant="outlined"
                  size="small"
                  placeholder="Dynamic Value"
                  labelId="dynamicValue"
                  id="dynamicValue-modal"
                  value={dataItem?.dynamicValue}
                  onChange={(e) => handleChange("dynamicValue", e.target.value)}
                >
                  {dynamicDBValues?.map((i) => (
                    <MenuItem key={i} value={i}>
                      {i}
                    </MenuItem>
                  ))}
                </Select>{" "}
              </FormControl>
            </div>
          ) : (
            <div className="w-full">
              <FormControl sx={{ m: 1, width: "45%" }}>
                <Select
                  variant="outlined"
                  size="small"
                  placeholder="Dynamic Value"
                  labelId="dynamicValue"
                  id="dynamicValue-modal"
                  value={dataItem?.dynamicValue}
                  onChange={(e) => handleChange("dynamicValue", e.target.value)}
                >
                  {dynamicDBValues?.map((i) => (
                    <MenuItem key={i} value={i}>
                      {i}
                    </MenuItem>
                  ))}
                </Select>{" "}
              </FormControl>
              <FormControl sx={{ m: 1, width: "45%", border: "none" }}>
                <TextField
                  size="small"
                  variant="outlined"
                  required
                  placeholder="Static Value"
                  value={dataItem?.staticValue}
                  onChange={(e) => {
                    handleChange("staticValue", e.target.value);
                  }}
                />
              </FormControl>
            </div>
          )}
        </div>
      );
    }
  };
  return (
    <Dialog
      maxWidth={'md'}
      fullWidth="false"
      sx={{ zIndex: 1000 }}
      open={true}
      onClose={props?.handleCloseDialog}
    >
      <DialogTitle
        sx={{ m: 0, p: 1, width: "auto", textAlign: "start", color: "#044A2A" }}
      >
        {"Add Fields"}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={props?.handleCloseDialog}
        sx={{
          position: "absolute",
          right: 3,
          top: 3,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <Divider />
      {Loading ? (
        <div style={{ width: "auto", height: "450px" }}>
          <DashboardLoader />
        </div>
      ) : (
        <>
          <DialogContent style={{ maxWidth: "auto", maxHeight: "450px" }}>
            <h6 style={{fontWeight:600}}>Added Variables</h6>
            <TableContainer component={Paper}>
              <Table size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <TableCell>Field Name</TableCell>
                    <TableCell>Field Type</TableCell>
                    <TableCell>Value</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {fieldsData?.map((row) => (
                    <TableRow
                      key={row?.intVendorAddedFieldsID?.toString()}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {row?.vchFieldName}
                      </TableCell>
                      <TableCell>{row?.vchFieldType}</TableCell>
                      <TableCell>{row?.vchFieldValue}</TableCell>
                      <TableCell>
                        <IconButton
                          onClick={() =>
                            handleDeleteField(row?.intVendorAddedFieldsID)
                          }
                        >
                          <img
                            src={"../../assets/images/delete-vendor.svg"}
                            alt="delete-vendor"
                          />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            {/* <p
          style={{
            paddingTop: "6px",
            color: " #1C1C1C",
            fontFamily: "Inter",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "normal",
          }}
        >
          Need more information how to add dynamic information ?{" "}
          <button
            style={{
              color: "#002EA5",
              fontFamily: "Inter",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 700,
              lineHeight: "normal",
              textDecorationLine: "underline",
            }}
          >
            Click here
          </button>
        </p> */}
            <div>
              <div
                className="w-full"
                sx={{ m: 1, minWidth: "95%", border: "none" }}
              >
                <FormControl sx={{p:1, minWidth: "95%", border: "none" }} >
                  <FormLabel id="demo-row-radio-buttons-group-label" style={{fontWeight:500,fontSize:'0.85rem',color:'#1976d2'}}>
                    Field Type
                  </FormLabel>
                  <RadioGroup
                    row
                    name="vchFieldType"
                    id="vchFieldType"
                    value={dataItem?.vchFieldType}
                   
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    onChange={(e) =>
                      handleChange("vchFieldType", e.target.value)
                    }
                  >
                    <FormControlLabel
                      value="static"
                      control={<Radio size="small" />}
                      label={<span style={{ fontSize: '0.75rem' }}>{"Static Variable"}</span>}
                      className="FieldType"
                    />
                    <FormControlLabel
                      value="dynamic"
                      className="FieldType"
                      control={<Radio />}
                      label={<span style={{ fontSize: '0.75rem' }}>{"Dynamic DB Value"}</span>}
                    />
                    <FormControlLabel
                      value="both"
                      className="FieldType"
                      style={{fontSize:'0.75rem'}}
                      control={<Radio size="small"  />}
                      label={<span style={{ fontSize: '0.75rem' }}>{"Both"}</span>}

                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <div className="w-full">
                <FormControl sx={{ m: 1, minWidth: "95%", border: "none" }}>
                  <TextField
                    size="small"
                    label="Field Name"
                    variant="outlined"
                    name="vchFieldName"
                    id="vchFieldName"
                    required
                    value={dataItem?.vchFieldName}
                    onChange={(e) => {
                      handleChange("vchFieldName", e.target.value);
                    }}
                  />
                </FormControl>
                {renderValueField()}
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <LoadingButton
              variant="contained"
              color="success"
              startIcon={<SaveIcon />}
              loading={btnLoading}
              loadingPosition="start"
              style={{ background: "#D41042" }}
              onClick={() => AddNewFields()}
            >
              Add New Field
            </LoadingButton>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default AddNewFields;
